import { motion } from "framer-motion";
import PaymentMethodListItem from "./PaymentMethodListItem";

function PaymentMethodList({ paymentMethods }) {
	const container = {
		show: {
			transition: {
				staggerChildren: 0.1,
			},
		},
	};

	const item = {
		hidden: { opacity: 0, y: 20 },
		show: { opacity: 1, y: 0 },
	};

	return (
		<motion.div
			variants={container}
			initial="hidden"
			animate="show"
			className="flex flex-wrap px-4"
		>
			{paymentMethods.map((paymentMethod, index) => (
				<motion.div
					variants={item}
					key={index}
					className="widget flex w-full sm:w-1/3 p-8"
				>
					<PaymentMethodListItem paymentMethod={paymentMethod} />
				</motion.div>
			))}
		</motion.div>
	);
}
export default PaymentMethodList;
